module.exports = "pegasus_template/assets/gray-ghost-linkedin.png";